import { types } from '../actions/UndoRedoActions';
import storeManager from '../store/StoreManager';
import saveManager from '../components/utils/SaveManager';

function addNewActionToHistory(state) {
    var undo = state.undo;
    var present = state.present;
    var appState = getCurrentState();

    if (present == undefined) {
        undo = [];
    } else {
        undo.push(present);
        saveManager.isContentChanged(true);
    }

    present = appState;

    return Object.assign({}, state, {undo: undo, redo: [], present: present});
}

function getCurrentState() {
    var currentState = storeManager.getState();
    var newState = {};

    newState.production = {};
    newState.production.slides = cloneArray(currentState.production.slides);
    newState.production.title = currentState.production.title;
    newState.production.mode = currentState.production.mode;
    newState.production.windowWidth = currentState.production.windowWidth;
    newState.production.windowHeight = currentState.production.windowHeight;
    newState.production.storySound = currentState.production.storySound;

    newState.currentSlide = {};
    newState.currentSlide.currentSlideIndex = currentState.currentSlide.currentSlideIndex;
    newState.currentSlide.model = {};
    newState.currentSlide.model.initialized = currentState.currentSlide.model.initialized;
    newState.currentSlide.model.uuid = currentState.currentSlide.model.uuid;
    newState.currentSlide.model.time = currentState.currentSlide.model.time;

    newState.currentSlide.model.soundEffect = currentState.currentSlide.model.soundEffect;
    newState.currentSlide.model.soundEffectTitle = currentState.currentSlide.model.soundEffectTitle;
    newState.currentSlide.model.contentItemIdSoundEffect = currentState.currentSlide.model.contentItemIdSoundEffect;
    newState.currentSlide.model.sound = currentState.currentSlide.model.sound;
    newState.currentSlide.model.soundTitle = currentState.currentSlide.model.soundTitle;
    newState.currentSlide.model.contentItemId = currentState.currentSlide.model.contentItemId;

    newState.currentSlide.model.content =  cloneArray(currentState.currentSlide.model.content);

    if (currentState.audioEditor && currentState.audioEditor.timelines) {
        newState.audioEditor = {};
        newState.audioEditor.timelines = cloneArray(currentState.audioEditor.timelines);

        if (currentState.audioEditor.zoomValue)
            newState.audioEditor.zoomValue = currentState.audioEditor.zoomValue;
        else
            newState.audioEditor.zoomValue = 4;
    }

    return newState;
}

function cloneArray(array) {
    var newItems = [];

    for (var i=0; i<array.length; i++) {
        var newItem = Object.assign({}, array[i]);
        newItems.push(newItem);
    }

    return newItems;
}

function undo(state) {
    var undo = state.undo;
    var redo = state.redo;
    var present = state.present;

    if (undo.length > 0) {
        redo.unshift(present);
        present = undo[undo.length - 1];
        undo.pop();
        saveManager.isContentChanged(true);
    }

    return Object.assign({}, state, {undo, redo, present});
}

function redo(state) {
    var undo = state.undo;
    var redo = state.redo;
    var present = state.present;

    if (redo.length > 0) {
        undo.push(present);
        present = redo[0];
        redo.splice(0, 1);
        saveManager.isContentChanged(true);
    }

    return Object.assign({}, state, {undo, redo, present});
}

export default function(state = {}, action) {

    switch (action.type) {
        case types.ADD_NEW_ACTION_TO_HISTORY:
            return addNewActionToHistory(state);

        case types.UNDO:
            return undo(state);

        case types.REDO:
            return redo(state);

        default:
            return state;
    }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/UndoRedoReducer.js
 **/